// extracted by extract-css-chunks-webpack-plugin
module.exports = {"community-member-type-option":"type-field__community-member-type-option___3-Hjx","communityMemberTypeOption":"type-field__community-member-type-option___3-Hjx"};
    if(module.hot) {
      // 1776124260401
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  